<!-- account-balance.component.html -->
<section class="summary-section">
  @if(!loading) {
    <div class="balance-items">
      @for (item of balanceItems; track item.label) {
        <div class="balance-card" [ngClass]="{'highlight': item.isTotal}">
          <p>{{ item.label }}
            <span class="value" [ngClass]="{'highlight-value': item.isTotal}">{{ item.value | currency }}</span>
          </p>
        </div>
      }
      
      <!-- Balance aging breakdown -->
      @if (showAgingDetails) {
        <div class="balance-aging-details">
          <div class="aging-header" (click)="toggleAgingDetails()">
            <span>Balance Aging Details</span>
            <mat-icon>{{ showAgingDetails ? 'expand_less' : 'expand_more' }}</mat-icon>
          </div>
          <div class="aging-items">
            @if (accountAgingBalance.Bal_0_30 > 0) {
              <div class="aging-item">
                <span>Current (0-30 days)</span>
                <span>{{ accountAgingBalance.Bal_0_30 | currency }}</span>
              </div>
            }
            @if (accountAgingBalance.Bal_31_60 > 0) {
              <div class="aging-item">
                <span>31-60 days</span>
                <span>{{ accountAgingBalance.Bal_31_60 | currency }}</span>
              </div>
            }
            @if (accountAgingBalance.Bal_61_90 > 0) {
              <div class="aging-item">
                <span>61-90 days</span>
                <span>{{ accountAgingBalance.Bal_61_90 | currency }}</span>
              </div>
            }
            @if (accountAgingBalance.BalOver90 > 0) {
              <div class="aging-item">
                <span>Over 90 days</span>
                <span>{{ accountAgingBalance.BalOver90 | currency }}</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="loading-spinner">
      <mat-progress-spinner [diameter]="25" mode="indeterminate"></mat-progress-spinner>
    </div>
  }
</section>